'use strict';

var d3 = require('d3');
var topojson = require('topojson');
var Datamap = require('../lib/datamaps.js');

function init() {
	var mapEl = document.getElementsByClassName('worldMap__map')[0];
	if (!mapEl)
		return;

	/**
	 * A distinct group of countries/regions on a map
	 * @param {*} config
	 */
	function Segment(config) {
		this.label = config.label;
		this.color = config.color;
		this.hoverColor = config.hoverColor;
		this.countries =
			Array.isArray(config.countries)
				? config.countries
				: typeof config.countries === 'string'
					? config.countries.split(',')
					: [];
		this.countriesObj = {}
		for (var i = 0; i < this.countries.length; i++) {
			this.countriesObj[this.countries[i]] = {
				fillColor: this.color,
				highlightFillColor: this.hoverColor
			}
		}
	}

	var segments = [];
	var segementEl = mapEl.getElementsByClassName('worldMap__segment');
	for (var i = 0; i < segementEl.length; i++) {
		segments.push(new Segment({
			label: segementEl[i].getAttribute('data-label'),
			color: segementEl[i].getAttribute('data-color'),
			hoverColor: segementEl[i].getAttribute('data-hover-color'),
			countries: segementEl[i].getAttribute('data-countries')
		}));
	}

	var map = new Datamap({
		element: mapEl,
		responsive: true,
		aspectRatio: 0.65625,
		projection: 'mercator',
		fills: {
			defaultFill: '#cccccc'
		},
		geographyConfig: {
			highlightFillColor: '#aaaaaa',
			highlightBorderColor: '#ffffff'
		}
	});

	for (var i = 0; i < segments.length; i++) {
		map.updateChoropleth(segments[i].countriesObj);
	}

	// window.addEventListener('resize', function() {
	// 	map.resize();
	// });
}

module.exports = {
	init: init
};
